import cx from 'classnames';
import { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { RemoveScroll } from 'react-remove-scroll';

import { PartialBy } from '../../../shared/utilities/types/PartialBy';

import { UseModalState } from './useModal';

import style from './ModalSkeleton.module.css';

// TODO: Rename medium to large
export type ModalSize = 'small' | 'medium' | 'fullscreen';

export type ModalSkeletonProps = PartialBy<UseModalState, 'open'> &
    PropsWithChildren<{
        size?: ModalSize;
        onClickOverlay?: () => void;
        className?: string;
    }>;

export function ModalSkeleton({
    isOpen,
    close,
    size = 'medium',
    onClickOverlay,
    className,
    children,
}: PropsWithChildren<ModalSkeletonProps>) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const handleClickOverlay = () => {
        if (onClickOverlay) {
            onClickOverlay();
        } else {
            close();
        }
    };

    if (!mounted || !isOpen) {
        return null;
    }

    const modal = (
        <RemoveScroll removeScrollBar>
            <div
                className={cx(style.modalWrapper, {
                    [style.small]: size === 'small',
                    [style.large]: size === 'medium',
                    [style.fullscreen]: size === 'fullscreen',
                })}
            >
                <div
                    className={cx(style.overlay, 'animate', 'animate-fast', 'animation-fade-in')}
                    onClick={handleClickOverlay}
                />
                <div className={cx(style.modal, 'animate', 'animation-slide-up', className)}>
                    {children}
                </div>
            </div>
        </RemoveScroll>
    );

    return createPortal(modal, document.querySelector<HTMLElement>('#modal-wrapper')!);
}
